// import {fetchInvoiceDetail} from 'api/documents';
// import {lockInvoiceCodes, unlockInvoiceCodes} from 'api/documents/documents';

import {combine, restore} from 'effector';

import {CreateInvoiceGate, rootDomain} from '../../domain';
import {getAdapter} from '../../init';

import {PackageTypes} from '../../types/gtins';
import {InvoiceLine} from '../../types/invoices';

import {
    $invoiceState,
    fetchInvoiceStatusAcceptedFx,
    fetchInvoiceStatusRejectedFx,
    generateIrnFx,
    updateInvoiceBodyFx,
} from '../common';
import {fetchInvocieXmlFx, fetchXmlValidationFx} from '../create';
import {$profile} from '../utils';

const domain = rootDomain.createDomain('InvoiceBodyDomain');

export const setCombineByGtin = domain.createEvent<boolean>();
export const $combineByGtin = restore(setCombineByGtin, true).reset(CreateInvoiceGate.close);

export const setCurrentScannedGtin = domain.createEvent<string | null>();
export const $currentScannedGtin = restore(setCurrentScannedGtin, null).reset(
    CreateInvoiceGate.close,
);

export const $inlineInvoiceChargeModal = domain
    .createStore<{
        index?: string;
        show: boolean;
    }>({
        index: undefined,
        show: false,
    })
    .reset(CreateInvoiceGate.close);

export const setInlineInvoiceChargeModal = domain.createEvent<{
    index?: string;
    show: boolean;
}>();

export const $inlineModalFormReadonly = domain
    .createStore<{
        index: string;
        show: boolean;
    }>({
        index: '-1',
        show: false,
    })
    .reset(CreateInvoiceGate.close);

export const setInlineModalFormReadonly = domain.createEvent<{
    index: string;
    show: boolean;
}>();

export const $modalDuplicateLinesModal = domain
    .createStore<{
        index?: number;
        show: boolean;
        initialLineData?: Partial<InvoiceLine>;
    }>({
        show: false,
    })
    .reset(CreateInvoiceGate.close);

export const setModalDuplicateLinesModal = domain.createEvent<{
    index?: number;
    show: boolean;
    initialLineData?: Partial<InvoiceLine>;
}>();

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: ({id, tin}: {id: string; tin?: string}) =>
        getAdapter().api.fetchInvoiceDetail({
            id,
            tin: $profile.getState()?.company.tin ?? tin ?? '',
        }),
});

export const commonData$ = domain.createStore<string | null>(null).reset(CreateInvoiceGate.close);

export const $everythingReady = combine($invoiceState, commonData$, (allDone, extraDone) => {
    if (allDone === 'new') {
        return true;
    }
    return allDone && extraDone;
}).reset(CreateInvoiceGate.close);

export const setModalViewCodesDropdown = domain.createEvent<string>();
export const $modalViewCodesDropdown = restore(setModalViewCodesDropdown, 'qwe').reset(
    CreateInvoiceGate.close,
);

export const $commonDataState = combine({
    data: commonData$,
    isLoading: fetchDataFx.pending,
}).reset(CreateInvoiceGate.close);

$inlineInvoiceChargeModal.reset(CreateInvoiceGate.close);
$modalDuplicateLinesModal.reset(CreateInvoiceGate.close);

export const $invoiceCreatingPending = combine(
    fetchInvoiceStatusRejectedFx.pending,
    fetchInvoiceStatusAcceptedFx.pending,
    updateInvoiceBodyFx.pending,
    fetchXmlValidationFx.pending,
    fetchInvocieXmlFx.pending,
    generateIrnFx.pending,
    (
        fetchInvoiceStatusRejectedFx,
        fetchInvoiceStatusAcceptedFx,
        updateInvoiceBodyFx,
        fetchXmlValidationFx,
        fetchInvocieXmlFx,
        generateIrnFx,
    ) =>
        fetchInvoiceStatusRejectedFx ||
        fetchInvoiceStatusAcceptedFx ||
        updateInvoiceBodyFx ||
        fetchXmlValidationFx ||
        fetchInvocieXmlFx ||
        generateIrnFx,
).reset(CreateInvoiceGate.close);

export const setInvoiceCreatingPending = domain.createEvent<boolean>();
